module.exports = __webpack_public_path__ + "0ec3b20443633d2672020cc3c58a7615.svg";